// extracted by mini-css-extract-plugin
module.exports =  {"settingsTitle":"HlQxtKc2","settingsDescription":"TMbWsj5Q"};